import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlusBoxStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPlusBoxStack12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#PlusBoxStack12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M3.214 1H10.5a.5.5 0 0 1 .5.5v7.286a.5.5 0 0 1-.5.5h-.214V3.214a1.5 1.5 0 0 0-1.5-1.5H2.714V1.5a.5.5 0 0 1 .5-.5m7.286 9.286h-.214v.214a1.5 1.5 0 0 1-1.5 1.5H1.5A1.5 1.5 0 0 1 0 10.5V3.214a1.5 1.5 0 0 1 1.5-1.5h.214V1.5a1.5 1.5 0 0 1 1.5-1.5H10.5A1.5 1.5 0 0 1 12 1.5v7.286a1.5 1.5 0 0 1-1.5 1.5M8.786 2.714H1.5a.5.5 0 0 0-.5.5V10.5a.5.5 0 0 0 .5.5h7.286a.5.5 0 0 0 .5-.5V3.214a.5.5 0 0 0-.5-.5m-3.643 1.81a.5.5 0 0 1 .5.5v1.333h1.333a.5.5 0 1 1 0 1H5.643v1.334a.5.5 0 1 1-1 0V7.357H3.309a.5.5 0 1 1 0-1h1.334V5.024a.5.5 0 0 1 .5-.5"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="PlusBoxStack12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPlusBoxStack12);
